export type { ConsoleDevice, ConsoleDeviceDoc } from '@gooduncles/gu-app-schema';

export const consoleDevicePath = 'consoleDevice';
